import { normalizeImageGallery } from './imageGallery';
import { mediaMintSettingsIssues, mediaMintSource, mediaMintSourceIssues } from '../../functions/mediaMintPolicy.js';

export { mediaMintSettingsIssues, mediaMintSourceIssues };

export const isMediaMintComponent = comp => ['image', 'video', 'audio'].includes(comp?.type);

// File pickers may report a count before their files have been uploaded.
export function mediaMintEligibility(comp, mediaCount) {
    if (!isMediaMintComponent(comp)) return 'Minting is available for image, audio, and video panels only.';
    const count = mediaCount ?? (comp.type === 'image' ? normalizeImageGallery(comp).length : 1);
    if (count > 1) return 'Minting requires a single media item. Remove the additional images or turn off minting.';
    return '';
}

export function mediaMintDefaults(comp, collection, archiveProvider = 'IRYS') {
    return {
        enabled: true, assetStandard: 'CORE', editionMode: 'LIMITED', supply: '1',
        collectionId: collection?.id || '', name: comp.title || comp.alt || comp.caption || '',
        description: comp.description || comp.caption || '', externalUrl: '',
        attributes: (collection?.attributes || []).map(attribute => ({
            name: attribute.trait_type || attribute.name || '', value: attribute.value ?? '',
        })),
        priceAmount: '', mediaStorage: 'ARCHIVE', archiveProvider,
        archiveStrategy: 'ARCHIVE_ON_FIRST_MINT',
    };
}

// Compare published content, ignoring unrelated styles and object key order.
export function mediaMintMatchesSaved(comp, saved) {
    const revision = value => JSON.stringify({ settings: value.mediaMint, source: mediaMintSource(value) },
        (_key, item) => item && typeof item === 'object' && !Array.isArray(item)
            ? Object.fromEntries(Object.keys(item).sort().map(key => [key, item[key]])) : item);
    return !!saved && comp.type === saved.type && revision(comp) === revision(saved);
}
